import { useCallback, useMemo, useState } from 'react';
import { ISelectOption, useDeviceType } from '@cian/ui-kit';
import { Prices } from 'shared/components/Prices';
import { PRICE_DEAL_TYPE_TABS } from 'shared/components/Prices/constants';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { filterPriceCategoriesByDealType } from 'shared/utils/filterPriceCategoriesByDealType';
import { PriceDealType, type IPriceCategory } from 'shared/types/pricesTable';

import { DEFAULT_POLYGONS } from './constants';

export const PricesContainer: React.FC = () => {
  const device = useDeviceType();
  const { config } = useApplicationContext();

  const polygons = useMemo(
    () => config.get<ISelectOption[]>('b2b-marketing-cpc-frontend.polygons') ?? DEFAULT_POLYGONS,
    [config],
  );

  const pricesByRegion = config.get<Record<string, IPriceCategory[]>>('b2b-marketing-cpc-frontend.pricesByPolygon');

  const [selectedPolygon, setSelectedPolygon] = useState<ISelectOption>(polygons[0]);
  const [dealType, setDealType] = useState<PriceDealType>(PriceDealType.Sale);

  const handlePolygonChange = useCallback(
    (value: string) => {
      setSelectedPolygon(polygons.find(polygon => polygon.value === value) as ISelectOption);
    },
    [polygons],
  );

  const filteredCategories = useMemo(() => {
    const categoriesForPolygon = pricesByRegion?.[selectedPolygon.value] ?? [];

    return filterPriceCategoriesByDealType(categoriesForPolygon, dealType);
  }, [pricesByRegion, selectedPolygon.value, dealType]);

  const dealTypeColumnTitle = useMemo(
    () => PRICE_DEAL_TYPE_TABS.find(tab => tab.value === dealType)?.label ?? PRICE_DEAL_TYPE_TABS[0].label,
    [dealType],
  );

  return (
    <Prices
      polygons={polygons}
      selectedValue={String(selectedPolygon?.value)}
      onPolygonChange={handlePolygonChange}
      dealType={dealType}
      onDealTypeChange={setDealType}
      categories={filteredCategories}
      device={device}
      dealTypeColumnTitle={dealTypeColumnTitle}
    />
  );
};
